import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <line x1="4" x2="20" y1="12" y2="12"/>
  <line x1="4" x2="20" y1="6" y2="6"/>
  <line x1="4" x2="20" y1="18" y2="18"/>
</svg>`;

const Menu = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='menu' svg={svg} {...props} />
  )
);

Menu.displayName = 'MenuIcon';

export default Menu;
